import {
  ECmomLogo,
  PortfolioLogo,
  SnapiaLogo,
  WeatherAppLogo,
} from "../Assets/AssetsList";

export const ProjectList = [
  // {
  //   key: 1,
  //   name: "Om Sai Motor Driving School",
  //   image: DrivingSchoolLogo,
  //   clientDemoLink: "https://omsaimotordrivingschool.in/",
  // },
  // {
  //   key: 2,
  //   name: "ShopIt(E-commerce)",
  //   image: ECmomLogo,
  //   skills: ["ReactJS, Recharts, Material UI,MongoDB, NodeJS, ExpressJS"],
  //   codeLink: "https://github.com/Saurabh-8585/MERN-E-Commerce-Frontend",
  //   demoLink: "https://e-shopit.vercel.app/",
  //   info: "The e-commerce web app is a feature-rich platform that provides user authentication and authorization using JWT. It has an admin dashboard for managing products, orders, users, and statistics. The platform includes a payment gateway and mail service, with features like Forgot Password and Reset Password. The platform also allows users to search for products, view product details and reviews, manage their cart, and track order history. Overall, it's a comprehensive platform that offers a seamless shopping experience for users.",
  //   youtube_url: "https://www.youtube.com/embed/0Fin1PrAnSg",
  // },
  // {
  //   key: 3,
  //   name: "Snapia (Social Media)",
  //   image: SnapiaLogo,
  //   skills: ["ReactJS, Tailwind CSS ,NodeJS ,ExpressJS, MongoDB, Socket.IO"],
  //   codeLink: "https://github.com/Saurabh-8585/MERN-Social-Media-Frontend",
  //   demoLink: "https://snapia.vercel.app",
  //   info: "Streamlined photo uploads through Cloudinary, Enhanced messaging capabilities by implementing Socket IO, enabling real-time messaging for improved communication.Empowered users to create accounts, post updates, follow others, and engage with posts through liking and commenting.Integrated cutting-edge features such as real-time chat, seamless login with Google, efficient photo uploads, interactive post interactions, robust password management, and precise location tracking for a comprehensive user experience.Developed a news section for users to read news, providing an additional value-added feature to the platform.",
  // },
  // {
  //   key: 4,
  //   name: "IMDB-Movie app Clone",
  //   image: IMDBLogo,
  //   skills: ["React,React Router,CSS,TMDB-API"],
  //   codeLink: "https://github.com/Saurabh-8585/IMDB-Clone",
  //   demoLink: "https://saurabh-imdbclone.netlify.app/",
  //   info: "As a web developer, I designed and built an IMDB clone website using React JS, HTML, and CSS. The website allows users to browse popular, top-rated, and upcoming movies, in addition to searching for specific movies. Users can also watch trailers, view cast information, and read reviews for each movie.To make this website possible, I utilized my skills [in web] development to create a functional and user-friendly application. Specifically, I made API calls to retrieve the necessary data and implemented various design features to enhance the user experience.",
  // },
  {
    key: 5,
    name: "React-Healthcare-Landing-Page",
    image: PortfolioLogo,
    skills: ["React,React Router,Tailwind CSS"],
    codeLink: "https://github.com/anirudhhbehera/React-Healthcare-Landing-Page",
    demoLink: "https://healthcare-landing-react-page.netlify.app/",
    info: "The React Healthcare Landing Page is a responsive single-page application built with React.js and styled using Tailwind CSS. It features a component-based architecture, utilizing React Hooks and React Router for smooth navigation. Tailwind CSS ensures a mobile-first, responsive design with minimal custom CSS. The project demonstrates modern front-end development practices like state management, lazy-loading, and optimized performance.",
  },
  {
    key: 6,
    name: "Custom Captcha in JavaScript",
    image: WeatherAppLogo,
    skills: ["HTML, CSS, JavaScript"],
    codeLink: "https://github.com/anirudhhbehera/Html-Css-Js-Project",
    demoLink: "https://anirudhhbehera.github.io/Html-Css-Js-Project/Custom-Captcha-in-JavaScript/index.html",
    info: "A custom CAPTCHA implementation using vanilla HTML, CSS, and JavaScript. Generates random alphanumeric codes, validates user input, and refreshes on demand — no third-party libraries.",
  },
  {
    key: 7,
    name: "SignUp & SignIn Page",
    image: SnapiaLogo,
    skills: ["HTML, CSS, JavaScript"],
    codeLink: "https://github.com/anirudhhbehera/Html-Css-Js-Project",
    demoLink: "https://anirudhhbehera.github.io/Html-Css-Js-Project/SignUp-SignIn-page/index.html",
    info: "A clean and modern SignUp & SignIn page built with HTML, CSS, and JavaScript. Features smooth toggle animations between the two forms with client-side validation.",
  },
  {
    key: 8,
    name: "SM Button Animation",
    image: ECmomLogo,
    skills: ["HTML, CSS, JavaScript"],
    codeLink: "https://github.com/anirudhhbehera/Html-Css-Js-Project",
    demoLink: "https://anirudhhbehera.github.io/Html-Css-Js-Project/sm-button-animation/index.html",
    info: "Smooth social media button hover animations built with pure HTML, CSS, and JavaScript. Features creative micro-interactions and transitions for a polished UI effect.",
  },
  // {
  //   key: 6,
  //   name: "Real Time Weather App",
  //   image: WeatherAppLogo,
  //   skills: ["React JS ,Open Weather API,HTML, CSS"],
  //   codeLink: "https://github.com/Saurabh-8585/WeatherApp",
  //   demoLink: "https://saurabh-8585.github.io/WeatherApp/",
  //   info: "I developed a real-time weather web application that is powered by the OpenWeatherAPI. The website provides up-to-date information on the current temperature, as well as the maximum and minimum temperature, weather, wind speed, sunrise and sunset times, humidity, and pressure.The user- friendly interface allows users to easily access the weather information for any location in the world.",
  // },
];

